import barba from "@barba/core";

export default class AdminToolbar {
  /**
   * @param {HTMLElement} element
   */
  constructor(element) {
    this.element = element;
    this.editLink = this.element.querySelector('.js-admin-edit-link');

    if (this.editLink) {
      this.init();
    }
  }

  init() {
    barba.hooks.after((data) => {
      const newEditUrl = this.getEditUrlFromNextPage(data.next.html);
      if (newEditUrl) {
        this.editLink.href = newEditUrl;
        this.editLink.classList.remove('hidden');
      } else {
        this.editLink.classList.add('hidden');
      }
    });
  }

  /**
   * @param {string} html
   * @returns {string|null}
   */
  getEditUrlFromNextPage(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const newEditLink = doc.querySelector('.js-admin-edit-link');
    return newEditLink ? newEditLink.getAttribute('href') : null;
  }
} 